import React, { useEffect, useState } from "react";
import style from "css/device.module.css";
import Warranty from "./warranty";
import Consult from "./consult";
import Experience from "./experience";
import SEOMeta from "components/app/SEOMeta";
import Questions from "components/app/questions";

function Pad(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <SEOMeta
        title="neat.pad, 리브테크놀로지"
        description="리브테크놀로지 riv Technology - neat.pad"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, pad, neat pad, 화상회의"
      />
      <div className={style.device_title_wrap}>
        <div className={style.device_subtitle}>
          <span>터치기반 AI</span> 회의 예약 컨트롤러
        </div>
        <div className={style.device_title}>
          <img
            className={style.big_title}
            src={
              `${process.env.REACT_APP_CLIENT_URL}` +
              `img/device/neat/title_neat_pad${isMobile ? "_m" : ""}.webp`
            }
            alt="pad"
          />
        </div>
      </div>
      <div className={style.device_text}>
        일반 회의실 및 화상회의실
        <br />
        예약 컨트롤러/디스플레이
      </div>

      <div className={style.device_img_list}>
        <img
          src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/pad_1${
            isMobile ? "_m" : ""
          }.webp`}
          alt="pad"
        />
        <img
          src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/pad_2${
            isMobile ? "_m" : ""
          }.webp`}
          alt="pad"
        />
      </div>

      <div className={style.device_description_wrap}>
        <div
          className={style.device_description_img_box}
          style={{ padding: "0px" }}
        >
          <img
            src={
              `${process.env.REACT_APP_CLIENT_URL}` +
              `img/device/neat/pad_device${isMobile ? "_m" : ""}.webp`
            }
            alt="pad"
          />
        </div>
        <div className={style.device_description_list_wrap}>
          <div className={style.device_description_list}>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/schedule${isMobile ? "_m" : ""}.webp`
                  }
                  alt="schedule"
                />
              </div>
              <div className={style.device_description_text}>
                회의실<span> 입구</span>에 설치되어
                <span> 회의일정 및 예약 가능</span>
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/iframe${isMobile ? "_m" : ""}.webp`
                  }
                  alt="iframe"
                />
              </div>
              <div className={style.device_description_text}>
                회의실 <span>안</span>에 설치되어
                <span> 회의 시작 및 화면 공유</span> 기능 (컨트롤러)
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/setting${isMobile ? "_m" : ""}.webp`
                  }
                  alt="setting"
                />
              </div>
              <div className={style.device_description_text}>
                <span>누구나</span> 쉽게 설치하고 간편한 설정 및 작동 가능
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/led${isMobile ? "_m" : ""}.webp`
                  }
                  alt="led"
                />
              </div>
              <div className={style.device_description_text}>
                회의실의 이용 가능 여부를 보여주는 <span>측면 LED 표시등</span>
              </div>
            </div>
          </div>

          <div className={style.device_support_platform_wrap}>
            <div className={style.device_support_platform_title_wrap}>
              <div className={style.device_support_platform_horizon}></div>
              <div className={style.device_support_platform_title}>
                지원 플랫폼
              </div>
            </div>
            <div className={style.device_support_platform_list}>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_zoom_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/zoom_logo${isMobile ? "_m" : ""}.webp`
                    }
                    alt="zoom"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>ZOOM</span>
                </div>
              </div>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_teams_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/teams_logo${isMobile ? "_m" : ""}.webp`
                    }
                    alt="teams"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>Microsoft Teams</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={style.device_vertical_line_wrap}>
        <div className={style.device_vertical_line}></div>
      </div>

      <div className={style.device_features_wrap}>
        <div className={style.device_features_title}>
          Neat Pad <span>특장점</span>
        </div>
        <div className={style.device_features_list}>
          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_pad_1${isMobile ? "_m" : ""}.webp`
                }
                alt="feature1"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"1".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  원 터치. 두 가지 메인 기능.
                </div>
              </div>
              <div className={style.device_features_text}>
                {`Neat Pad는 회의를 컨트롤하거나 회의실 외부에서 이용 가능 여부를 표시해주고${
                  isMobile ? " " : "\n"
                }` +
                  `회의실을 예약하는데 사용할 수 있는 심플하고 세련된 터치 스크린입니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_pad_2${isMobile ? "_m" : ""}.webp`
                }
                alt="feature2"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"2".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  직관적인 LED 디스플레이
                </div>
              </div>
              <div className={style.device_features_text}>
                {`회의실 외부에 설치하여 멀리서도 이용 여부를 한 눈에 인식할 수 있습니다.\n` +
                  `면의 LED 표시등은 지정된 시간에 빨간색 및 녹색으로\n` +
                  `회의실의 이용 가능 여부를 보여줍니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_pad_3${isMobile ? "_m" : ""}.webp`
                }
                alt="feature3"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"3".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  회의 컨트롤러
                </div>
              </div>
              <div className={style.device_features_text}>
                {`컨트롤러로서 Neat Pad를 사용하면 단 한 번의 탭으로 신속하게 회의를 시작하고${
                  isMobile ? " " : "\n"
                }` +
                  `화면을 공유할 수 있습니다. 참가자를 초대하고 음소거하거나 회의를 녹음할 수도${
                    isMobile ? " " : "\n"
                  }` +
                  `있으며 컨트롤러 기능에는 2개의 내장 마이크가 있습니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_pad_4${isMobile ? "_m" : ""}.webp`
                }
                alt="feature4"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"4".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  간단한 설정
                </div>
              </div>
              <div className={style.device_features_text}>
                {
                  "벽면 및 측면 장착 부품과 함께 제공됩니다.\n벽걸이를 사용하여 회의실 벽에 고정할 수 있으며,\n측면 마운트를 사용하면 문틀이나 가장자리에 고정할 수 있습니다.\n\n하나의 PoE (Power over Ethernet)케이블을 통해\n항상 on상태를 유지하고 바로 사용할 수 있습니다."
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      <Experience />

      <div className={style.device_spec_wrap}>
        <div className={style.device_spec_title}>제품 사양</div>

        <div className={style.device_size_img_wrap}>
          <div className={style.device_img_wrap}>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                `img/device/neat/spec_pad_1${isMobile ? "_m" : ""}.webp`
              }
              alt="spec1"
            />
          </div>
          <div className={style.device_spec_img_wrap}>
            <div className={style.device_spec_img_box}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_pad_2${isMobile ? "_m" : ""}.webp`
                }
                alt="spec2"
              />
            </div>
            <div className={style.device_spec_img_box}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_pad_3${isMobile ? "_m" : ""}.webp`
                }
                alt="spec3"
              />
            </div>
          </div>
        </div>

        <div className={style.device_spec_text_wrap}>
          <div className={style.device_spec_text_group}>
            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "67px" }}
            >
              <div className={style.device_spec_text_label}>일반</div>
              <div className={style.device_spec_text}>
                <span>8인치 터치 스크린</span>
                <span>1280 x 800 화면 해상도</span>
                <span>16:10 종횡비</span>
                <span>눈부심 방지, 얼룩 방지 코팅</span>
                <span>주변광 센서</span>
                <span>온도, 습도, CO 2 및 VOC</span>
                <span>센서 측면 LED 표시기</span>
                <span>가속도계</span>
                <span>벽면 장착 및 측면 장착</span>
                <span>보안 잠금 슬롯(Kensington 호환)</span>
                <span>울트라소닉 공유 기능</span>
                <span>
                  마이크 2개 내장 (추후 소프트웨어 업데이트를 통한 지원)
                </span>
                <span>PoE를 통한 전원공급 (어댑터 제공)</span>
                <span>WiFi 네트워크 연결</span>
              </div>
            </div>
          </div>
          <div className={style.device_spec_text_group}>
            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "45px" }}
            >
              <div className={style.device_spec_text_label}>
                네트워크 & 포트
              </div>
              <div className={style.device_spec_text}>
                <span>WiFi</span>
                <span>Bluetooth</span>
                <span>USB-C (향후 사용을 위해 예약됨)</span>
                <span>이더넷(PoE 지원)</span>
                <span>AC용 전원 어댑터 (옵션)</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "145px" }}
            >
              <div className={style.device_spec_text_label}>구성품</div>
              <div className={style.device_spec_text}>
                <span>2 × 이더넷 케이블(3미터+5미터)</span>
                <span>PoE 전원 어댑터</span>
                <span>마운트 어댑터, 측면 마운트 및 벽면 마운트</span>
                <span>벽면 마운트용 M4 나사 4개(0.39인치/10mm)</span>
                <span>사이드 마운트용 M4 나사 3개(0.26인치/6.7mm)</span>
                <span>2mm 육각렌치</span>
                <span>2.5mm 육각렌치</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "87px" }}
            >
              <div className={style.device_spec_text_label}>크기 및 무게</div>
              <div className={style.device_spec_text}>
                <span>너비: 198mm(7.8인치)</span>
                <span>높이: 42mm(1.7인치)</span>
                <span>깊이: 127mm(5인치)</span>
                <span>무게: 520g(1.15파운드)</span>
              </div>
            </div>
          </div>
        </div>

        <div
          className={style.device_spec_icon_wrap}
          style={{
            backgroundImage:
              "url('" +
              `${process.env.REACT_APP_CLIENT_URL}` +
              `img/device/neat/spec_pad_bg${isMobile ? "_m" : ""}.webp')`,
          }}
        >
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>8″</div>
            <div className={style.device_spec_icon_label}>HD 터치스크린</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>LED</div>
            <div className={style.device_spec_icon_label}>상태 표시기</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.pairing_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/pairing${isMobile ? "_m" : ""}.webp`
                }
                alt="pairing"
              />
            </div>
            <div className={style.device_spec_icon_label}>무선 공유</div>
          </div>

          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>PoE</div>
            <div className={style.device_spec_icon_label}>Support</div>
          </div>

          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.wifi_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/wifi${isMobile ? "_m" : ""}.webp`
                }
                alt="wifi"
              />
            </div>
            <div className={style.device_spec_icon_label}>와이파이</div>
          </div>

          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.light_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/light${isMobile ? "_m" : ""}.webp`
                }
                alt="light"
              />
            </div>
            <div className={style.device_spec_icon_label}>조도센서</div>
          </div>

          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.rotate_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/rotate${isMobile ? "_m" : ""}.webp`
                }
                alt="rotate"
              />
            </div>
            <div className={style.device_spec_icon_label}>방향 센서</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.fan_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/fan${isMobile ? "_m" : ""}.webp`
                }
                alt="fan"
              />
            </div>
            <div className={style.device_spec_icon_label}>공기질 센서</div>
          </div>
        </div>

        <Warranty />
      </div>

      {props.type === "popup" ? (
        <div style={{ marginBottom: "70px" }}>
          <Consult />
        </div>
      ) : (
        <div className={style.device_consult_wrapper}>
          <Questions />
        </div>
      )}
    </>
  );
}

export default Pad;
